import { LabelOrMarkerVisualizerContainer } from '~/_shared/labelOrMarkerVisualizer/labelOrMarkerVisualizer.container';
import { MarkerStyleType } from '~/_shared/types/marker.types';
import { MarkerSettingType } from '~/_shared/types/markers/visualSettings.enums';
import { useTranslation } from '~/_shared/utils/hooks';
import {
  DEFAULT_NUMERIC_GREEN_MARKER_COLOR, ID_OF_GROWING_NUMERIC_MARKER,
} from '~/_shared/utils/markers/markerVisualSettings.constants';
import { type NumericalGroupSettingsSameSizeMarkerProps } from '../numericalGroupSettings.component';
import { BubbleMarkerLabelFrameComponent } from './bubbleMarkerLabelFrame.component';
import { BucketMarkerVisualType } from './bucketMarkerVisualType.enum';

const MARKER_DIMENSION = 38;
const MARKER_COLOR_GRADIENT = 'linear-gradient(90deg, #8FE04C 20%, #FFD200 40%, #A61B1B 60%)';

export const MulticolorPinMarkerLabelComponent = ({
  sameSizeMarkerProps,
}: {
  sameSizeMarkerProps?: NumericalGroupSettingsSameSizeMarkerProps;
}) => {
  const [t] = useTranslation();

  return (
    <BubbleMarkerLabelFrameComponent title={t(`numericalMarkers.${BucketMarkerVisualType.SameSizePin}.label`)}>
      <LabelOrMarkerVisualizerContainer
        colorGradient={MARKER_COLOR_GRADIENT}
        maxDimensions={{ height: MARKER_DIMENSION, width: MARKER_DIMENSION }}
        markerSettings={{
          useMarker: true,
          marker: {
            opacity: 1,
            selectedColor: DEFAULT_NUMERIC_GREEN_MARKER_COLOR,
            size: 100,
            styleId: sameSizeMarkerProps?.styleId ?? ID_OF_GROWING_NUMERIC_MARKER,
            styleType: MarkerStyleType.STANDARD,
          },
        }}
        visualSettingsType={MarkerSettingType.Marker}
      />
    </BubbleMarkerLabelFrameComponent>
  );
};
